import React, { VFC, useState } from 'react'
import { PasswordInput, TextInput } from '@designsforhealth/dfh-react-components'
import { FieldErrors, UseFormMethods } from 'react-hook-form'
import * as Styled from './styled'

export interface RegistrationFormPasswordInputsProps {
  defaultValue?: string
  disabled?: boolean
  errors?: FieldErrors
  register: UseFormMethods['register']
  watch: UseFormMethods['watch']
}

export const RegistrationFormPasswordInputs: VFC<RegistrationFormPasswordInputsProps> = ({
  defaultValue = '',
  disabled = false,
  errors,
  register,
  watch,
}) => {
  const [showPassword, setPasswordVisible] = useState(false)
  const [showConfirmPassword, setConfirmPasswordVisible] = useState(false)

  const MainInput = showPassword ? TextInput : PasswordInput
  const ConfirmInput = showConfirmPassword ? TextInput : PasswordInput

  const { password, password2 } = watch(['password', 'password2'])
  return (
    <div>
      <Styled.InputContainer>
        {/* TODO: Show/Hide password should be handled inside PasswordInput component, toggling the type to text/password */}
        <MainInput
          autoComplete="new-password"
          label="Password"
          name="password"
          register={register}
          errors={errors}
          required
          disabled={disabled}
          defaultValue={defaultValue || password}
          data-cy="registration-input-password"
        />
        <Styled.ShowHideButton
          type="button"
          tabIndex={-1}
          onClick={() => {
            setPasswordVisible(!showPassword)
          }}
        >
          {showPassword ? 'Hide' : 'Show'}
        </Styled.ShowHideButton>
      </Styled.InputContainer>
      <Styled.InputContainer>
        {/* TODO: Show/Hide password should be handled inside PasswordInput component, toggling the type to text/password */}
        <ConfirmInput
          autoComplete="new-password"
          label="Confirm Password"
          name="password2"
          register={register}
          errors={errors}
          required
          disabled={disabled}
          defaultValue={defaultValue || password2}
          data-cy="registration-input-password2"
        />
        <Styled.ShowHideButton
          type="button"
          tabIndex={-1}
          onClick={() => {
            setConfirmPasswordVisible(!showConfirmPassword)
          }}
        >
          {showConfirmPassword ? 'Hide' : 'Show'}
        </Styled.ShowHideButton>
      </Styled.InputContainer>
    </div>
  )
}
